var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { FieldType } from '../../redux/questionnaire/typings';
import endpoints from '../../const/apiEndpoints';
import fetchRequest from '../../services/fetchRequest';
export var textboxQuestions = ['Q60', 'Q91', 'SQ17'];
export var textboxToTextarea = function (question) {
    var _a;
    if (textboxQuestions.includes(question.id)) {
        return question;
    }
    var answer = (_a = question === null || question === void 0 ? void 0 : question.answers) === null || _a === void 0 ? void 0 : _a[0];
    // Convert the answer options' metadata first
    var answerOptions = answer === null || answer === void 0 ? void 0 : answer.answerOptions.map(function (answerOption) {
        var _a;
        var metadataAnswer = (_a = answerOption.metadata) === null || _a === void 0 ? void 0 : _a[0];
        if ((metadataAnswer === null || metadataAnswer === void 0 ? void 0 : metadataAnswer.fieldType) === FieldType.TextBox &&
            (metadataAnswer === null || metadataAnswer === void 0 ? void 0 : metadataAnswer.type) === 'text') {
            return __assign(__assign({}, answerOption), { metadata: [
                    __assign(__assign({}, metadataAnswer), { fieldType: FieldType.TextArea })
                ] });
        }
        return answerOption;
    });
    // Convert the answer type itself and use the formatted answer options
    if ((answer === null || answer === void 0 ? void 0 : answer.fieldType) === FieldType.TextBox && (answer === null || answer === void 0 ? void 0 : answer.type) === 'text') {
        return __assign(__assign({}, question), { answers: [
                __assign(__assign({}, answer), { fieldType: FieldType.TextArea, answerOptions: __spreadArray([], answerOptions, true) })
            ] });
    }
    return question;
};
var questionnaire = endpoints.questionnaire;
var questionnaireApi = {
    postFetchQuestions: function (_a) {
        var accountId = _a.accountId, transactionId = _a.transactionId, operationId = _a.operationId, referenceNumber = _a.referenceNumber, transactionCode = _a.transactionCode, transactionDate = _a.transactionDate, transactionAmount = _a.transactionAmount, statementDate = _a.statementDate, apiHost = _a.apiHost;
        return __awaiter(void 0, void 0, void 0, function () {
            var transactions, transaction;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, fetchRequest.post(apiHost, questionnaire, {
                            'cipher.accountId': accountId,
                            accountIdType: 'guid',
                            transactions: [
                                __assign({ id: transactionId, operationId: operationId, referenceNumber: referenceNumber, transactionCode: transactionCode, date: transactionDate, amount: transactionAmount }, (statementDate ? { statementDate: statementDate } : null))
                            ]
                        })];
                    case 1:
                        transactions = (_c.sent()).transactions;
                        transaction = transactions[0];
                        return [2 /*return*/, __assign(__assign({}, transaction), { questionnaire: (_b = transaction === null || transaction === void 0 ? void 0 : transaction.questionnaire) === null || _b === void 0 ? void 0 : _b.map(textboxToTextarea) })];
                }
            });
        });
    }
};
export default questionnaireApi;
//# sourceMappingURL=questionnaire.js.map